import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Kontaktoplysninger", -1)
const _hoisted_3 = {
  "aria-label": "kontaktoplysninger",
  class: "table table--borderless table--compact table--responsive-headers d-print-table"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = {
  key: 0,
  class: "align-text-md-right d-print-none mb-2"
}
const _hoisted_7 = ["id", "onClick"]
const _hoisted_8 = {
  key: 1,
  style: {"min-width":"10%"}
}
const _hoisted_9 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("use", {
  color: "#c00",
  "xlink:href": "#error"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  "aria-label": "Opsummering af blanket",
  class: "table table--borderless table--compact table--responsive-headers d-print-table"
}
const _hoisted_13 = ["id"]
const _hoisted_14 = ["id"]
const _hoisted_15 = {
  key: 0,
  class: "align-text-md-right d-print-none mb-2"
}
const _hoisted_16 = ["id", "onClick"]
const _hoisted_17 = {
  key: 1,
  style: {"min-width":"10%"}
}
const _hoisted_18 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("use", {
  color: "#c00",
  "xlink:href": "#error"
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["id"]
const _hoisted_23 = ["id"]
const _hoisted_24 = {
  key: 0,
  class: "align-text-md-right d-print-none mb-2"
}
const _hoisted_25 = ["id", "onClick"]
const _hoisted_26 = {
  key: 1,
  style: {"min-width":"10%"}
}
const _hoisted_27 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("use", {
  color: "#c00",
  "xlink:href": "#error"
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.formular.contactInfo != null)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formular.contactInfo.felter.filter(f => f.felttype !== _ctx.FeltType.OVERSKRIFT && f.felttype !== _ctx.FeltType.HIDDEN), (felt) => {
                return (_openBlock(), _createElementBlock("tr", { key: felt }, [
                  _createElementVNode("th", {
                    class: "w-percent-md-30",
                    id: 'maerkat_' + _ctx.genererDomId(felt.tcoElementName)
                  }, _toDisplayString(felt.maerkat), 9, _hoisted_4),
                  _createElementVNode("td", {
                    style: {"width":"80%"},
                    id: 'vaerdi_' + _ctx.genererDomId(felt.tcoElementName)
                  }, _toDisplayString(_ctx.lavVistNavn(felt)), 9, _hoisted_5),
                  (this.editable && !felt.readOnly)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                        _createElementVNode("a", {
                          id: 'redigerKnap_' + _ctx.genererDomId(felt.tcoElementName),
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.redigerFelt(felt, 0))
                        }, [
                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.opsummering.knap.rediger' }, null, 8, ["tekstNoegle"])
                        ], 8, _hoisted_7)
                      ]))
                    : _createCommentVNode("", true),
                  (this.editable)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                        (!felt.erValid)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formular.trin.filter(tr => !tr.overskrift.includes('Opsummering') && !tr.overskrift.includes('opsummering')), (trin) => {
      return (_openBlock(), _createElementBlock("span", { key: trin }, [
        _createElementVNode("h3", null, _toDisplayString(trin.overskrift), 1),
        _createElementVNode("table", _hoisted_12, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trin.felter.filter(f => f.felttype !== _ctx.FeltType.OVERSKRIFT && f.felttype !== _ctx.FeltType.HIDDEN), (felt) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: felt }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    class: "w-percent-md-30",
                    id: 'maerkat_' + _ctx.genererDomId(felt.tcoElementName)
                  }, _toDisplayString(felt.maerkat), 9, _hoisted_13),
                  _createElementVNode("td", {
                    style: {"width":"80%"},
                    id: 'vaerdi_' + _ctx.genererDomId(felt.tcoElementName)
                  }, _toDisplayString(_ctx.lavVistNavn(felt)), 9, _hoisted_14),
                  (this.editable)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                        _createElementVNode("a", {
                          id: 'redigerKnap_' + _ctx.genererDomId(felt.tcoElementName),
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.redigerFelt(felt, trin.trin))
                        }, [
                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.opsummering.knap.rediger' }, null, 8, ["tekstNoegle"])
                        ], 8, _hoisted_16)
                      ]))
                    : _createCommentVNode("", true),
                  (this.editable)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                        (!felt.erValid)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_20))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (felt.felttype === _ctx.FeltType.RADIO_JA_NEJ_MED_INPUT)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                      _createElementVNode("th", {
                        class: "w-percent-md-30",
                        id: 'maerkat_' + _ctx.genererDomId(_ctx.isJaValgt(felt) ? felt.jaInputTcoElementName : felt.nejInputTcoElementName)
                      }, _toDisplayString(_ctx.isJaValgt(felt) ? felt.jaInputMaerkat : felt.nejInputMaerkat), 9, _hoisted_22),
                      _createElementVNode("td", {
                        style: {"width":"80%"},
                        id: 'vaerdi_' + _ctx.genererDomId(_ctx.isJaValgt(felt) ? felt.jaInputTcoElementName : felt.nejInputTcoElementName)
                      }, _toDisplayString(_ctx.formatNumeric(_ctx.isJaValgt(felt) ? felt.jaInputVaerdi : felt.nejInputVaerdi)) + " " + _toDisplayString(_ctx.isJaValgt(felt) ? felt.jaInputEnhed : felt.nejInputEnhed), 9, _hoisted_23),
                      (this.editable)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                            _createElementVNode("a", {
                              id: 'redigerKnap_' + _ctx.genererDomId(_ctx.isJaValgt(felt) ? felt.jaInputTcoElementName : felt.nejInputTcoElementName),
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.redigerFelt(felt, trin.trin))
                            }, [
                              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.opsummering.knap.rediger' }, null, 8, ["tekstNoegle"])
                            ], 8, _hoisted_25)
                          ]))
                        : _createCommentVNode("", true),
                      (this.editable)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                            (!felt.erValid)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_27, _hoisted_29))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ])
      ]))
    }), 128))
  ], 64))
}